import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Path } from '../path.enum';

@Injectable({
  providedIn: 'root',
})
export class FilmDetailService {
  filmPath = `${environment.apiUrl}${Path.FILM_PATH}`;
  webSeriesPath = `${environment.apiUrl}${Path.WEB_SERIES_PATH}`;

  constructor(private http: HttpClient) {}

  getFilmDetail(id: string): Observable<any> {
    return this.http.get<any>(`${this.filmPath}/${id}`);
  }

  getWebSeriesDetail(id: string): Observable<any> {
    return this.http.get<any>(`${this.webSeriesPath}/${id}`);
  }
}
